import { Component, ViewChild, ElementRef } from '@angular/core';
import { HttpService } from 'src/app/http.service';
// import { async } from '@angular/core/testing';
// import * as moment from 'moment';
import { FormControl } from '@angular/forms';
import { GlobalService } from 'src/app/global.service';
import { AgentService } from '../agent.service';
import { MatDialog } from '@angular/material/dialog';
import { AgentConfirmOrderComponent } from '../agent-confirm-order/agent-confirm-order.component';
import { AgentOrderEditComponent } from '../agent-order-edit/agent-order-edit.component';
import * as $ from 'jquery';
import { ZoneWiseCountComponent } from '../zone-wise-count/zone-wise-count.component';
import { UserIsActiveService } from 'src/app/services/user-is-active.service';
import { AgentMobileConfirmationComponent } from 'src/app/agent-mobile-confirmation/agent-mobile-confirmation.component';
import { IfStmt } from '@angular/compiler';


@Component({
  selector: 'app-agent-order',
  templateUrl: './agent-order.component.html',
  styleUrls: ['./agent-order.component.scss']
})


export class AgentOrderComponent {
  receivedDepositAmount: any;
  payment: number;
  counter_ids: Boolean = false;
  product_list: any;
  session_list: any;
  today_date_time: any;
  today_date: any = new Date().toISOString().split('T')[0];
  product_form_dict: any = {};
  final_price: any = 0;
  order_date_list: any[] = [];
  future_order_date_list: any[] = [];
  selected_index: any = 0;
  form_start_date = null;
  duplicate_order_date_list: any;
  customer_wallet: any;
  customer_wallet_after_edit: any;
  tomorrow: any;
  is_wallet_selected = true;
  final_customer_wallet: any; // final customer wallet price
  final_price_before_wallet = 0;
  product_availability: any;
  business_type_id: any;
  products: any = [];
  business_confirmed = false;
  business_details = {};
  date = null;
  selected_business_code: any = null;
  is_business_selected = false;
  final_price_after_wallet: number;
  wallet_balance: number;
  order_details: any;
  product_groupby_list: any;
  enable_minimum_warning_for_loose_milk: boolean = false;
  display_confirmed_bill: boolean = false;
  booth_details: any = null;
  is_counter_selected = false;
  counter_list: any = null;
  sale_group_data: any;
  login_users: any;
  counter_name: any;
  one_week_order_details: any;
  product_quantity_variation_list: any;
  collection_center: any = [];
  logged_user_befere_select_counter: any;
  total_amount_in_counter: any = 0;
  total_booth_count: any;
  curd_product_index: any;
  enable_loose_milk_card = true;
  is_date_editable = false;
  route_indent_prepate_status_per_session = { 1: false, 2: false };
  employee_user_type_id: any;
  is_session_wise_edit = { 1: false, 2: false };
  business_wise_future_order_dict: any;
  is_order_data_changeable: any = false;
  show_order_table = true;
  future_order_alert_content = '';
  milk_product_list = [];
  is_counter_enable: any;
  requiresmaxLimit: boolean;
  counter_id: any = [];
  business_id: any = [];
  wallet_amount: any = [];
  business_group_id: any;
  min_max_limit_dict: any;

  // Product group limit tracking
  productGroupTotals: { [groupId: number]: number } = {};
  productGroupNames: { [groupId: number]: string } = {
    1: 'Milk',
    2: 'Fermented Products',
    3: 'Loose Milk'
  };
  sessionNames: { [sessionId: number]: string } = {
    1: 'Morning',
    2: 'Evening'
  };
  ordered_booth_code_with_count = {};


  constructor(private http: HttpService, private global: GlobalService, private service: AgentService, public dialog: MatDialog, private userIsActiveService: UserIsActiveService) {
    this.today_date_time = new Date();
    let today = new Date();
    today.setDate(new Date().getDate() + 1);
    this.tomorrow = new Date(today).toISOString().split('T')[0];
    this.global.set_master_page_title = 'Agent Order';
    document.onkeypress = ((event) => {
      if (this.selected_business_code !== null) {
        if (event.keyCode === 13 && event.shiftKey) {
          document.getElementById('confirm_button').focus();
        }
      }
    });
    this.http.getEmployeeUserType().subscribe((data) => {
      this.employee_user_type_id = data;
    }, (error) => {
      console.error(error);
    });

    this.http.serveUnActiveCounter().subscribe((data) => {
      if (data === 'counter already selected') {
        this.is_counter_selected = true;
        setTimeout(() => document.getElementById('booth_number').focus(), 500);
        this.serveCounteOrders();
        this.serveLastMonthOrderCount();
      } else {
        this.counter_list = data['counter_data'];
        this.collection_center = Object.keys(this.counter_list);
        this.logged_user_befere_select_counter = data['logged_users'];
      }
    }, (error) => {
      // this.userIsActiveService.checkUserIsActive();
      console.error('❌ serveUnActiveCounter error:', error);
    });
  }

  changeToEditableDate() {
    this.is_date_editable = true;
  }

  openLooseMilkCard() {
    this.enable_loose_milk_card = !this.enable_loose_milk_card;
  }

  // moving cursour to next input box if its disabled recall function itself
  enterKeyCalled(session_id, product_index, date) {
    if (session_id === 2 && product_index === this.curd_product_index) {
      document.getElementById('confirm_button').focus();
    } else if (session_id === 2 && product_index + 1 === this.product_list.length) {
      document.getElementById('confirm_button').focus();
    } else {
      if (session_id === 1) {
        session_id = 2;
      } else {
        session_id = 1;
        product_index = product_index + 1;
      }
      let session_obj = this.session_list.filter((element) => {
        return element.id === session_id;
      });
      if (this.checkExpiry(date, session_obj[0], this.product_list[product_index])) {
        this.enterKeyCalled(session_id, product_index, date);
      } else {
        let next_element_id = session_id + '_' + product_index;
        if (document.getElementById(next_element_id) !== null) {
          document.getElementById(next_element_id).focus();
        }
      }
    }
  }

  leftArrowKeyCalled(session_id, product_index, date) {
    if (session_id === 1 && product_index === 0) {
    } else {
      if (session_id === 1) {
        session_id = 2;
        product_index -= 1;
      } else {
        session_id = 1;
      }
      let session_obj = this.session_list.filter((element) => {
        return element.id === session_id;
      });
      if (this.checkExpiry(date, session_obj[0], this.product_list[product_index])) {
        this.leftArrowKeyCalled(session_id, product_index, date);
      } else {
        let next_element_id = session_id + '_' + product_index;
        if (document.getElementById(next_element_id) !== null) {
          document.getElementById(next_element_id).focus();
        }
      }
    }
  }

  upArrowKeyCalled(session_id, product_index, date) {
    if (product_index === 0) {
    } else {
      product_index -= 1;
      let session_obj = this.session_list.filter((element) => {
        return element.id === session_id;
      });
      if (this.checkExpiry(date, session_obj[0], this.product_list[product_index])) {
        this.upArrowKeyCalled(session_id, product_index, date);
      } else {
        let next_element_id = session_id + '_' + product_index;
        if (document.getElementById(next_element_id) !== null) {
          document.getElementById(next_element_id).focus();
        }
      }
    }
  }

  rightArrowKeyCalled(session_id, product_index, date) {
    if (session_id === 2 && product_index === this.curd_product_index) {
      document.getElementById('confirm_button').focus();
    } else if (session_id === 2 && product_index + 1 === this.product_list.length) {
      document.getElementById('confirm_button').focus();
    } else {
      if (session_id === 1) {
        session_id = 2;
      } else {
        session_id = 1;
        product_index = product_index + 1;
      }
      let session_obj = this.session_list.filter((element) => {
        return element.id === session_id;
      });
      if (this.checkExpiry(date, session_obj[0], this.product_list[product_index])) {
        this.rightArrowKeyCalled(session_id, product_index, date);
      } else {
        let next_element_id = session_id + '_' + product_index;
        if (document.getElementById(next_element_id) !== null) {
          document.getElementById(next_element_id).focus();
        }
      }
    }
  }

  downArrowKeyCalled(session_id, product_index, date) {
    if (session_id === 2 && product_index === this.curd_product_index) {
      document.getElementById('confirm_button').focus();
    } else if (product_index + 1 === this.product_list.length) {
      document.getElementById('confirm_button').focus();
    } else {
      product_index += 1;
      let session_obj = this.session_list.filter((element) => {
        return element.id === session_id;
      });
      if (this.checkExpiry(date, session_obj[0], this.product_list[product_index])) {
        this.downArrowKeyCalled(session_id, product_index, date);
      } else {
        let next_element_id = session_id + '_' + product_index;
        if (document.getElementById(next_element_id) !== null) {
          document.getElementById(next_element_id).focus();
        }
      }
    }
  }

  eventEmitOnInput(session_id, product_index, date, event) {
    let key_code = event.keyCode;
    if (key_code === 13) {
      this.enterKeyCalled(session_id, product_index, date);
    } else if (key_code === 37) {
      this.leftArrowKeyCalled(session_id, product_index, date);
    } else if (key_code === 38) {
      this.upArrowKeyCalled(session_id, product_index, date);
    } else if (key_code === 39) {
      this.rightArrowKeyCalled(session_id, product_index, date);
    } else if (key_code === 40) {
      this.downArrowKeyCalled(session_id, product_index, date);
    }
  }

  serveLastMonthOrderCount() {
    this.http.serveLastMonthCounterOrder().subscribe((data) => {
      this.ordered_booth_code_with_count = data;
    }, (error) => {
      console.error(error);
    });
  }

  serveCounteOrders() {
    this.http.serveCounteOrders().subscribe((data) => {
      this.sale_group_data = data['sale_data'];
      this.login_users = data['login_users'];
      this.total_amount_in_counter = data['total_quantity'];
      this.counter_name = this.login_users[0]['counter_name'];
      this.total_booth_count = data['total_booth_count'];
    }, (error) => {
      console.error(error);
    });
  }

  counterClicked(counter_id) {
    this.global.set_counter_id = counter_id;
    let data_dict = {
      'counter_id': counter_id
    };
    this.http.serveCounterStop(data_dict).subscribe((data) => {
      this.is_counter_enable = data['is_counter_enable']
      if (this.is_counter_enable == false) {
        alert(data['alert_text']);
        return false;
      }
      this.http.assignCounterToEmployee(data_dict).subscribe((data) => {
        if (!data['is_taken']) {
          this.is_counter_selected = true;
          setTimeout(() => document.getElementById('booth_number').focus(), 500);
          this.serveCounteOrders();
          this.serveLastMonthOrderCount();
        } else {
          alert('Selected counter is already taken by' + data['taken_by']);
          return false;
        }
      }, (error) => {
        this.is_counter_selected = false;
        console.error(error);
      });
    });
  }

  getLastDateOrder() {
    const request_data = {
      from: 'portal',
      business_code: this.selected_business_code
    };
    this.http.getLastDateForAgentOrder(request_data).subscribe((data) => {
      this.booth_details = data;
      this.is_business_selected = true;
      this.selected_index = 0;
      this.final_price = 0;
      this.is_date_editable = false;
      if (!data['is_mobile_verified']) {
        const dialogRef = this.dialog.open(AgentMobileConfirmationComponent, {
          height: '550px',
          width: '600px',
          data: {
            'user_id': data['user_id'],
            'mobile': data['agent_mobile']
          },
        });
        dialogRef.afterClosed().subscribe(result => {
        });
      }
      // this.service.set_booth_data = this.selected_business_code;
      // this.service.getHistory.emit(true);
      this.serveProductList();
    }, (error) => {
      this.is_business_selected = false;
      this.selected_business_code = null;
      console.info(error);
      alert(error['error']['error_message']);
      this.counter_ids = false;
    });
  }

  checkConfirmButtonValid() {
    // Check if there are any validation errors using the new min_max_limit_dict system
    if (this.order_date_list.length > 0) {
      for (let i = 0; i < this.order_date_list.length; i++) {
        const date = this.order_date_list[i];
        const validation = this.validateAllLimits(date);
        if (!validation.isValid) {
          return true; // Disable button if there are validation errors
        }
      }
    }

    // Check other conditions
    if (this.final_price == 0) {
      return true;
    }

    if (this.enable_minimum_warning_for_loose_milk) {
      return true;
    }

    return false;
  }


  getBusinessLastSale() {
    this.show_order_table = true;
    if (this.selected_business_code == null || this.selected_business_code === '') {
      alert('Please enter a booth code to Search for');
      return false;
    }
    if (this.ordered_booth_code_with_count.hasOwnProperty(this.selected_business_code)) {
      if (this.ordered_booth_code_with_count[this.selected_business_code] < 4) {
        if (confirm(String(this.selected_business_code) + ' நீங்கள் வழக்கமாக  ஆர்டர் செய்யும் பூத் அல்ல.கண்டிப்பாக ஆர்டர் செய்ய வேண்டுமா?')) {
          this.getLastDateOrder();
          this.counter_ids = true;
        } else {
          this.clearFormIsCalled();
          this.counter_ids = false;
          return false;
        }
      } else {
        this.getLastDateOrder();
      }
    } else {
      if (confirm(String(this.selected_business_code) + ' நீங்கள் வழக்கமாக  ஆர்டர் செய்யும் பூத் அல்ல.கண்டிப்பாக ஆர்டர் செய்ய வேண்டுமா?')) {
        this.getLastDateOrder();
        this.counter_ids = true;
      } else {
        this.clearFormIsCalled();
        this.counter_ids = false;
        return false;
      }
    }
    let last_date_date = this.booth_details;
    this.form_start_date = last_date_date && last_date_date.hasOwnProperty("next_date_from_last_date")
      ? last_date_date["next_date_from_last_date"] < this.tomorrow
        ? this.tomorrow
        : last_date_date["next_date_from_last_date"]
      : this.tomorrow
    let data_dict = {
      request_from: 'portal',
      order_date: this.form_start_date,
      business_code: this.selected_business_code.toString()
    };
    this.http.getProductList(data_dict).subscribe(async (data) => {
      this.business_id = data['business_id'];
      this.business_group_id = data['business_group_id'];
      this.business_type_id = data['business_type_id'];
      let data_dict = {
        business_code: this.selected_business_code,
        business_type_id: this.business_type_id,
      }
      this.http.receivedDepositAmount(data_dict).subscribe((data) => {
        this.wallet_amount = data;
      });
    });
    this.counter_ids = true;
  }


  async serveProductList() {
    this.is_order_data_changeable = false;
    this.product_form_dict = {};
    let last_date_date = this.booth_details;
    this.form_start_date = last_date_date.hasOwnProperty("next_date_from_last_date")
      ? last_date_date["next_date_from_last_date"] < this.tomorrow
        ? this.tomorrow
        : last_date_date["next_date_from_last_date"]
      : this.tomorrow
    let data_dict = {
      request_from: 'portal',
      order_date: this.form_start_date,
      business_code: this.selected_business_code.toString()
    };
    this.http.getProductList(data_dict).subscribe(async (data) => {
      this.product_list = data['product_list'];
      this.business_id = data['business_id']

      // Store the min_max_limit_dict for validation
      this.min_max_limit_dict = data['min_max_limit_dict'];

      this.session_list = data['session_list'];
      let curd_index = this.product_list.map((element) => {
        return element.product_id;
      }).indexOf(25);
      this.curd_product_index = curd_index;
      this.product_availability = data['product_availability'];
      this.product_groupby_list = data['product_groupby_list'];
      this.product_quantity_variation_list = data['product_quantity_variation_list'];
      this.business_wise_future_order_dict = data['business_wise_future_order_dict'];

      this.future_order_alert_content = data['future_order_alert_content'];
      this.milk_product_list = data['milk_product_list'];

      let last_date_date = this.booth_details;
      this.customer_wallet = last_date_date['wallet_balance'];
      this.final_customer_wallet = last_date_date['wallet_balance'];
      this.business_type_id = last_date_date['business_type_id'];
      if (last_date_date['is_exists']) {
        await this.getRouteIndentCloseStatus();
        let last_date_product_data = last_date_date['last_date_product_data'];
        this.product_form_dict[this.form_start_date] = {};
        this.product_form_dict[this.form_start_date]['product'] = {};
        this.product_form_dict[this.form_start_date]['total_price_per_product'] = {};
        this.product_form_dict[this.form_start_date]['total_price_per_session'] = {};
        this.product_form_dict[this.form_start_date]['total_price_per_date'] = last_date_product_data['total_price_per_date']
        data['session_list'].forEach(session_element => {
          this.product_form_dict[this.form_start_date]['product'][session_element.id] = {};
          if (last_date_product_data['product'].hasOwnProperty(session_element.id)) {
            if (last_date_product_data['total_price_per_session'].hasOwnProperty(session_element.id)) {
              this.product_form_dict[this.form_start_date]['total_price_per_session'][session_element.id] = last_date_product_data['total_price_per_session'][session_element.id];
            } else {
              this.product_form_dict[this.form_start_date]['total_price_per_session'][session_element.id] = 0;
            }
            data['product_list'].forEach(product_element => {
              if (!this.checkExpiryForLoadingOldOrder(this.form_start_date, session_element, product_element)) {
                this.is_session_wise_edit[session_element.id] = true;
                if (last_date_product_data['product'][session_element.id].hasOwnProperty(product_element.product_id)) {
                  this.product_form_dict[this.form_start_date]['product'][session_element.id][product_element.product_id] = {};
                  this.product_form_dict[this.form_start_date]['product'][session_element.id][product_element.product_id]['quantity'] = last_date_product_data['product'][session_element.id][product_element.product_id]['quantity'];
                  this.product_form_dict[this.form_start_date]['product'][session_element.id][product_element.product_id]['price'] = last_date_product_data['product'][session_element.id][product_element.product_id]['quantity'] * product_element['product_mrp'];
                } else {
                  this.product_form_dict[this.form_start_date]['product'][session_element.id][product_element.product_id] = {
                    'quantity': null,
                    'price': 0
                  };
                }
              } else {
                this.product_form_dict[this.form_start_date]['product'][session_element.id][product_element.product_id] = {
                  'quantity': null,
                  'price': 0
                };
              }
            });
          } else {
            this.product_form_dict[this.form_start_date]['total_price_per_session'][session_element.id] = 0;
            data['product_list'].forEach(product_element => {
              this.product_form_dict[this.form_start_date]['product'][session_element.id][product_element.product_id] = {
                'quantity': null,
                'price': 0
              };
            });
          }
        });
        this.product_form_dict[this.form_start_date]['total_price_per_date'] = 0;
        data['product_list'].forEach(product_element => {
          let total_cost = 0;
          data['session_list'].forEach(session_element => {
            total_cost += this.product_form_dict[this.form_start_date]['product'][session_element.id][product_element.product_id]['price'];
          });
          this.product_form_dict[this.form_start_date]['total_price_per_product'][product_element.product_id] = total_cost;
          this.product_form_dict[this.form_start_date]['total_price_per_date'] += this.product_form_dict[this.form_start_date]['total_price_per_product'][product_element.product_id];
        });
        this.final_price = this.product_form_dict[this.form_start_date]['total_price_per_date'];
        this.final_price_before_wallet = this.product_form_dict[this.form_start_date]['total_price_per_date'];
        if (this.final_price <= 0) {
          this.final_price = 0;
          this.final_price_before_wallet = 0;
        }

        this.order_date_list = Object.keys(this.product_form_dict);
        this.duplicate_order_date_list = Object.keys(this.product_form_dict);
      } else {
        this.form_start_date = this.tomorrow;

        await this.getRouteIndentCloseStatus();

        this.product_form_dict[this.form_start_date] = {};
        this.product_form_dict[this.form_start_date]['product'] = {};
        this.product_form_dict[this.form_start_date]['total_price_per_product'] = {};
        this.product_form_dict[this.form_start_date]['total_price_per_session'] = {};
        this.product_form_dict[this.form_start_date]['total_price_per_date'] = 0;
        data['session_list'].forEach(session_element => {
          this.product_form_dict[this.form_start_date]['product'][session_element.id] = {};
          this.product_form_dict[this.form_start_date]['total_price_per_session'][session_element.id] = 0;
          data['product_list'].forEach(product_element => {
            this.product_form_dict[this.form_start_date]['product'][session_element.id][product_element.product_id] = {
              'quantity': null,
              'price': 0
            };
            this.product_form_dict[this.form_start_date]['total_price_per_product'][product_element.product_id] = 0;
          });
        });
        this.order_date_list = Object.keys(this.product_form_dict);
        this.duplicate_order_date_list = Object.keys(this.product_form_dict);
      }
      if (this.business_wise_future_order_dict[this.business_type_id]['is_future_order_accept']) {
        this.is_order_data_changeable = true;
        this.future_order_alert_content = this.future_order_alert_content + ' பதியவேண்டுமா?';
      } else {
        this.future_order_alert_content = this.future_order_alert_content + ' செய்ய இயலாது.';
      }
      if (this.employee_user_type_id == 2) {
        this.is_order_data_changeable = true;
        this.future_order_alert_content = this.future_order_alert_content + ' பதியவேண்டுமா?';
      }
      if (this.form_start_date > this.tomorrow) {
        if (confirm(this.future_order_alert_content)) {
          if (!this.business_wise_future_order_dict[this.business_type_id]['is_future_order_accept']) {
            if (this.employee_user_type_id !== 2) {
              this.show_order_table = false;
            }
          }
        } else {
          this.clearFormIsCalled();
          return false;
        }
      }

      // Old overall_litre_limit logic removed - now handled by min_max_limit_dict

      // Initialize product group totals for UI display
      this.calculateProductGroupTotals(this.form_start_date);

      setTimeout(() => document.getElementById('1_0').focus(), 500);
      this.serveOrderForFutureWeeks();
    }, (error) => {
      console.error(error);
    });
  }

  getRouteIndentCloseStatus() {
    let data_dict = {
      'selected_date': this.form_start_date,
      'selected_business_code': this.selected_business_code
    };
    return this.http.getRouteIndentStatusPerSession(data_dict).toPromise().then((data) => {
      this.route_indent_prepate_status_per_session[1] = data[1];
      this.route_indent_prepate_status_per_session[2] = data[2];
    }, (error) => {
      console.error(error);
    });
  }

  checkLooseMilkQuantityWarning(date, product_index) {
    this.enable_minimum_warning_for_loose_milk = false;

    if (this.product_groupby_list && this.product_groupby_list[3]) {
      this.product_groupby_list[3].forEach((loose_milk_id) => {
        this.session_list.forEach(session_element => {
          let value = this.product_form_dict[date]['product'][session_element.id][loose_milk_id]['quantity'];
          if (value !== null && value !== 0) {
            if (value < this.product_list[product_index]['minimum_quantity']) {
              this.enable_minimum_warning_for_loose_milk = true;
            }
          }
        });
      });
    }
  }

  checkExpiryForLoadingOldOrder(order_date, session, product) {
    let order_date_in_format = new Date(order_date);
    let expiry_date: any = new Date(order_date_in_format.setDate(order_date_in_format.getDate() - session.expiry_day_before));
    expiry_date = expiry_date.toISOString().split('T')[0];
    let expiry_date_and_time: any = new Date(expiry_date + ' ' + session.expiry_time);
    if (this.route_indent_prepate_status_per_session[session.id]) {
      return true;
    } else if (this.product_availability[session.id][product.product_id] === false) {
      return true;
    } else if (new Date() > expiry_date_and_time) {
      return true;
    } else {
      return false;
    }
  }

  checkExpiry(order_date, session, product) {
    let order_date_in_format = new Date(order_date);
    let expiry_date: any = new Date(order_date_in_format.setDate(order_date_in_format.getDate() - session.expiry_day_before));
    expiry_date = expiry_date.toISOString().split('T')[0];
    let expiry_date_and_time: any = new Date(expiry_date + ' ' + session.expiry_time);
    if (this.employee_user_type_id === 2) {
      return false;
    } else if (this.route_indent_prepate_status_per_session[session.id]) {
      return true;
    } else if (this.product_availability[session.id][product.product_id] === false) {
      return true;
    } else if (new Date() > expiry_date_and_time) {
      return true;
    } else {
      return false;
    }
  }

  productQuantityChanged(date, session_id, product_id, product_price, product_index, product_quantity) {
    const product_group_id = this.product_list[product_index]['product_group_id'];
    let temp_quantity = this.product_form_dict[date]['product'][session_id][product_id]['quantity'];
    if (temp_quantity !== '') {
      this.is_session_wise_edit[session_id] = true;
      this.product_form_dict[date]['product'][session_id][product_id]['quantity'] = parseInt(this.product_form_dict[date]['product'][session_id][product_id]['quantity']);
    } else {
      this.product_form_dict[date]['product'][session_id][product_id]['quantity'] = null;
    }
    let quantity = this.product_form_dict[date]['product'][session_id][product_id]['quantity'];
    if (product_group_id === 3) {
      this.checkLooseMilkQuantityWarning(date, product_index);
      this.product_form_dict[date]['product'][session_id][product_id]['price'] = 0;
      this.product_quantity_variation_list[product_id].forEach(element => {
        if (quantity >= element['min_quantity'] && quantity <= element['max_quantity']) {
          this.product_form_dict[date]['product'][session_id][product_id]['price'] = quantity * element['mrp'];
        }
      });
    } else {
      this.product_form_dict[date]['product'][session_id][product_id]['price'] = quantity * product_price;
    }
    // add the product session based total price
    let total_cost = 0;
    let total_litre = 0;
    this.session_list.forEach(session_element => {
      total_cost += this.product_form_dict[date]['product'][session_element.id][product_id]['price'];
      total_litre += (this.product_form_dict[date]['product'][session_element.id][product_id]['quantity'] * product_quantity) / 1000;
    });
    this.product_form_dict[date]['total_price_per_product'][product_id] = total_cost;

    // add the total product price date wise
    this.product_form_dict[date]['total_price_per_date'] = 0;
    this.product_list.forEach(product_element => {
      this.product_form_dict[date]['total_price_per_date'] += this.product_form_dict[date]['total_price_per_product'][product_element.product_id];
    });
    // add total price per session
    let total_cost_per_session = 0;
    this.product_form_dict[date]['total_price_per_session'][session_id] = 0;
    this.product_list.forEach(product_element => {
      total_cost_per_session += this.product_form_dict[date]['product'][session_id][product_element.product_id]['price'];
    });
    this.product_form_dict[date]['total_price_per_session'][session_id] = total_cost_per_session;
    // add final total price
    this.final_price = 0;
    // this.final_price_before_wallet = 0;
    this.order_date_list.forEach(element => {
      this.final_price += this.product_form_dict[element]['total_price_per_date'];
      this.final_price_before_wallet += this.product_form_dict[element]['total_price_per_date'];
    });

    // Update product group totals for UI display
    this.calculateProductGroupTotals(date);
  }

  minValue(index) {
    if (this.employee_user_type_id === 2) {
      return '2020-04-01';
    } else if (this.order_date_list.length === 1) {
      return this.tomorrow;
    } else {
      return this.order_date_list[index];
    }
  }

  async dateValueChanged(index, date) {
    this.display_confirmed_bill = false;
    let old_date = this.duplicate_order_date_list[index];
    this.form_start_date = date;
    await this.getRouteIndentCloseStatus();
    let data_dict = {
      'date': date,
      'from': 'portal',
      'business_code': this.selected_business_code
    };
    this.http.checkOrderExists(data_dict).subscribe((data) => {
      if (data['is_exists']) {
        alert('Aleardy you have order in this date');
        this.order_date_list[index] = old_date;
      } else {
        if (this.duplicate_order_date_list.includes(date)) {
          this.order_date_list[index] = old_date;
          alert('This date already available');
        } else {
          delete Object.assign(this.product_form_dict, { [date]: this.product_form_dict[old_date] })[old_date];
          this.duplicate_order_date_list[index] = date;
        }
      }

    }, (error) => {
      console.error(error);
    });
  }

  serveOrderForFutureWeeks() {
    let data_dict = {
      'from': 'portal',
      'booth_code': this.selected_business_code
    };
    this.http.serveBoothOrderHistoryForFuture(data_dict).subscribe((data) => {
      this.future_order_date_list = Object.keys(data);
      this.one_week_order_details = {};
      this.future_order_date_list.forEach((date_element, date_index) => {
        this.one_week_order_details[date_element] = {};
        this.one_week_order_details[date_element]['session'] = {};
        this.one_week_order_details[date_element]['per_date'] = data[date_element]['per_date'];
        this.one_week_order_details[date_element]['counter_name'] = data[date_element]['counter_name'];
        this.one_week_order_details[date_element]['per_product'] = {};
        this.session_list.forEach(session_element => {
          this.one_week_order_details[date_element]['session'][session_element.id] = {};
          this.one_week_order_details[date_element]['session'][session_element.id]['product'] = {};
          this.one_week_order_details[date_element]['session'][session_element.id]['order_date_and_time'] = {};
          this.one_week_order_details[date_element]['session'][session_element.id]['order_date_and_time']['time_created'] = null;
          this.one_week_order_details[date_element]['session'][session_element.id]['order_date_and_time']['time_modified'] = null;
          this.one_week_order_details[date_element]['session'][session_element.id]['order_date_and_time']['ordered_by'] = null;
          this.one_week_order_details[date_element]['session'][session_element.id]['order_date_and_time']['modified_by'] = null;
          if (data[date_element]['session'].hasOwnProperty(session_element.id)) {
            this.product_list.forEach(product_element => {
              if (data[date_element]['session'][session_element.id]['product'].hasOwnProperty(product_element.product_id)) {
                this.one_week_order_details[date_element]['session'][session_element.id]['product'][product_element.product_id] = data[date_element]['session'][session_element.id]['product'][product_element.product_id];
              } else {
                this.one_week_order_details[date_element]['session'][session_element.id]['product'][product_element.product_id] = 0;
              }
            });
            this.one_week_order_details[date_element]['session'][session_element.id]['order_date_and_time']['time_created'] = data[date_element]['session'][session_element.id]['order_date_and_time']['time_created'];
            this.one_week_order_details[date_element]['session'][session_element.id]['order_date_and_time']['ordered_by'] = data[date_element]['session'][session_element.id]['order_date_and_time']['ordered_by'];
            if (new Date(data[date_element]['session'][session_element.id]['order_date_and_time']['time_created']).getTime() !== new Date(data[date_element]['session'][session_element.id]['order_date_and_time']['time_modified']).getTime()) {
              this.one_week_order_details[date_element]['session'][session_element.id]['order_date_and_time']['time_modified'] = data[date_element]['session'][session_element.id]['order_date_and_time']['time_modified'];
              this.one_week_order_details[date_element]['session'][session_element.id]['order_date_and_time']['modified_by'] = data[date_element]['session'][session_element.id]['order_date_and_time']['modified_by'];
            }
          } else {
            this.product_list.forEach(product_element => {
              this.one_week_order_details[date_element]['session'][session_element.id]['product'][product_element.product_id] = 0;
            });
          }
        });
        this.product_list.forEach(product_element => {
          if (data[date_element]['per_product'].hasOwnProperty(product_element.product_id)) {
            this.one_week_order_details[date_element]['per_product'][product_element.product_id] = data[date_element]['per_product'][product_element.product_id];
          } else {
            this.one_week_order_details[date_element]['per_product'][product_element.product_id] = 0;
          }
        });
      });
    }, (error) => {
      console.error(error);
    });
  }

  checkEnableEditButton(date) {
    let today = new Date();
    let current_time = today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();
    // console.log(this.today_date + ' ' + current_time);
    // console.log(date + ' ' + this.session_list[1]['expiry_time']);
    // todaya current tome < order date and eve tim
    if (Date.parse(this.today_date + ' ' + current_time) < Date.parse(date + ' ' + this.session_list[1]['expiry_time'])) {
      return true;
    } else {
      return false;
    }
  }

  clearFormIsCalled() {
    this.final_price = null;
    this.order_date_list = [];
    this.selected_index = 0;
    this.form_start_date = null;
    this.duplicate_order_date_list = [];
    this.customer_wallet = null;
    this.customer_wallet_after_edit = null;
    this.is_wallet_selected = null;
    this.final_customer_wallet = null;
    this.final_price_before_wallet = null;
    this.product_availability = null;
    this.selected_business_code = null;
    this.is_business_selected = false;
    this.is_date_editable = false;
    window.scrollTo(0, 0);
    setTimeout(() => document.getElementById('booth_number').focus(), 500);
    this.counter_ids = false
  }

  async addNewFormClicked() {
    this.display_confirmed_bill = false;
    let last_index = this.order_date_list.length - 1;
    let last_index_date: any = this.order_date_list[last_index];
    let last_index_date_in_format: any = new Date(last_index_date);
    let tomorrow: any = new Date(last_index_date_in_format.setDate(last_index_date_in_format.getDate() + 1));
    tomorrow = tomorrow.toISOString().split('T')[0];
    if (this.order_date_list.length === 1) {
      let data_dict = {
        'date': tomorrow,
        'from': 'portal',
        'business_code': this.selected_business_code
      };
      this.http.checkOrderExists(data_dict).subscribe((data) => {
        if (data['is_exists']) {
          tomorrow = data['last_date']
          this.order_date_list.push(tomorrow);
          this.duplicate_order_date_list.push(tomorrow);
          this.product_form_dict[tomorrow] = JSON.parse(JSON.stringify(this.product_form_dict[last_index_date]));
          let after_new_date_last_index = this.order_date_list.length - 1;
          this.selected_index = after_new_date_last_index;
        } else {
          this.order_date_list.push(tomorrow);
          this.duplicate_order_date_list.push(tomorrow);
          this.product_form_dict[tomorrow] = JSON.parse(JSON.stringify(this.product_form_dict[last_index_date]));
          let after_new_date_last_index = this.order_date_list.length - 1;
          this.selected_index = after_new_date_last_index;
        }
      }, (error) => {
        console.error(error);
      });
    } else {
      this.order_date_list.push(tomorrow);
      this.duplicate_order_date_list.push(tomorrow);
      this.product_form_dict[tomorrow] = JSON.parse(JSON.stringify(this.product_form_dict[last_index_date]));
      let after_new_date_last_index = this.order_date_list.length - 1;
      this.selected_index = after_new_date_last_index;
    }
    this.order_date_list.forEach(element => {
      this.final_price += this.product_form_dict[element]['total_price_per_date'];
      // this.final_price_before_wallet += this.product_form_dict[element]['total_price_per_date'];
    });
  }

  removeFormClicked() {
    this.display_confirmed_bill = false;
    let last_index = this.order_date_list.length - 1;
    let last_index_date: any = this.order_date_list[last_index];
    delete this.product_form_dict[last_index_date];
    this.order_date_list.pop();
    this.duplicate_order_date_list.pop();
    this.final_price = 0;
    this.final_price_before_wallet = 0;
    this.order_date_list.forEach(element => {
      this.final_price += this.product_form_dict[element]['total_price_per_date'];
      // this.final_price_before_wallet += this.product_form_dict[element]['total_price_per_date'];
    });
    let after_new_date_last_index = this.order_date_list.length - 1;
    this.selected_index = after_new_date_last_index;
  }



  async confirmCliked() {
    // Validate using new min_max_limit_dict structure
    let allValidationErrors: string[] = [];

    for (let i = 0; i < this.order_date_list.length; i++) {
      const date = this.order_date_list[i];
      const validation = this.validateAllLimits(date);

      if (!validation.isValid) {
        validation.errors.forEach(error => {
          allValidationErrors.push(`Date ${date}: ${error}`);
        });
      }
    }

    if (allValidationErrors.length > 0) {
      alert(allValidationErrors.join("\n"));
      return false;
    }



    document.getElementById('confirm_button').blur();
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
    var id = this.global.get_counter_id;
    const dialogRef = this.dialog.open(AgentConfirmOrderComponent, {
      height: '394px',
      width: '600px',
      data: {
        'order_details': this.product_form_dict,
        'wallet_balance': this.customer_wallet,
        'final_price': this.final_price,
        'order_dates': this.order_date_list,
        'business_code': this.selected_business_code,
        'is_session_wise_edit': this.is_session_wise_edit,
        'counter_id': id,
        'business_id': this.business_id,
        'business_group_id': 1,
        'business_type_id': this.business_type_id
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      const res = result;
      if (res) {
        this.serveCounteOrders();
        this.clearFormIsCalled();
        this.is_session_wise_edit = { 1: false, 2: false };
        this.counter_ids = false;
      }
    });

  }

  editClicked(selected_date) {
    const dialogRef = this.dialog.open(AgentOrderEditComponent, {
      height: '600px',
      width: '600px',
      data: {
        'selected_date': selected_date,
        'selected_business_code': this.selected_business_code,
        'business_type_id': this.business_type_id
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      const res = result;
      if (res) {
        this.serveOrderForFutureWeeks();
        this.serveCounteOrders();
      }
    });
  }

  editViaCounterCliked(date, business_code, business_type_id) {
    var id = this.global.get_counter_id;
    const dialogRef = this.dialog.open(AgentOrderEditComponent, {
      height: '600px',
      width: '600px',
      data: {
        'selected_date': date,
        'selected_business_code': business_code,
        'business_type_id': business_type_id,
        'counter_id': id,
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      const res = result;
      if (res) {
        this.serveCounteOrders();
        if (this.is_business_selected) {
          this.serveOrderForFutureWeeks();
        }
      }
    });
  }


  formExpandClicked(index) {
    if (this.selected_index === index) {
      this.selected_index = null;
    } else {
      this.selected_index = index;
    }
  }

  openZoneWiseCountCliked() {
    const dialogRef = this.dialog.open(ZoneWiseCountComponent, {
      height: '550px',
      width: '600px',
      data: {},
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  // ===== COMPREHENSIVE VALIDATION SYSTEM =====
  // This system validates in three levels:
  // 1. Overall product group limits (whole day)
  // 2. Session-wise limits  
  // 3. Individual product limits

  /**
   * Level 1: Check overall product group limits for whole day
   * IMPORTANT: Validates ALL product groups with limits if ANY product is entered (not just the group of the entered product)
   */
  validateProductGroupOverallLimits(date: string): { isValid: boolean, errors: string[] } {
    const errors: string[] = [];

    if (!this.min_max_limit_dict || !this.min_max_limit_dict.min_max_product_group_wholeday_limit) {
      return { isValid: true, errors: [] };
    }

    const sessionData = this.product_form_dict[date] && this.product_form_dict[date].product;
    if (!sessionData) {
      return { isValid: true, errors: [] };
    }

    // Check if ANY product is entered in ANY session
    let anyProductEntered = false;
    this.session_list.forEach(session => {
      if (this.product_form_dict[date] && this.product_form_dict[date].product && this.product_form_dict[date].product[session.id]) {
        Object.keys(this.product_form_dict[date].product[session.id]).forEach(productIdStr => {
          const productId = parseInt(productIdStr);
          const quantity = this.product_form_dict[date].product[session.id][productId].quantity;
          if (quantity > 0) {
            anyProductEntered = true;
          }
        });
      }
    });

    // If no products are entered, no validation needed
    if (!anyProductEntered) {
      return { isValid: true, errors: [] };
    }

    // Calculate whole day totals for ALL product groups
    const productGroupTotals: { [groupId: number]: number } = {};
    this.product_list.forEach(product => {
      const groupId = product.product_group_id;
      let groupTotal = 0;
      this.session_list.forEach(session => {
        const quantity = (this.product_form_dict[date] && this.product_form_dict[date].product && this.product_form_dict[date].product[session.id] && this.product_form_dict[date].product[session.id][product.product_id]) ? this.product_form_dict[date].product[session.id][product.product_id].quantity : 0;
        groupTotal += (quantity * product.product_quantity) / 1000; // Convert to litres
      });
      productGroupTotals[groupId] = (productGroupTotals[groupId] || 0) + groupTotal;
    });

    // Validate ALL product groups with limits, even if no product from that group is entered
    Object.keys(this.min_max_limit_dict.min_max_product_group_wholeday_limit).forEach(groupIdStr => {
      const groupId = parseInt(groupIdStr);
      const wholeDayTotal = productGroupTotals[groupId] || 0;
      const groupLimit = this.min_max_limit_dict.min_max_product_group_wholeday_limit[groupId];
      if (groupLimit) {
        const groupName = this.productGroupNames[groupId] || `Product Group ${groupId}`;
        // ONLY validate minimum if min_litre is NOT NULL
        if (groupLimit.min_litre !== null && groupLimit.min_litre !== undefined) {
          if (wholeDayTotal < groupLimit.min_litre) {
            errors.push(`${groupName} needs at least ${groupLimit.min_litre}L for the whole day (current: ${wholeDayTotal.toFixed(2)}L)`);
          }
        }
        // ONLY validate maximum if max_litre is NOT NULL  
        if (groupLimit.max_litre !== null && groupLimit.max_litre !== undefined) {
          if (wholeDayTotal > groupLimit.max_litre) {
            errors.push(`${groupName} cannot exceed ${groupLimit.max_litre}L for the whole day (current: ${wholeDayTotal.toFixed(2)}L)`);
          }
        }
      }
    });

    return { isValid: errors.length === 0, errors };
  }

  /**
   * Level 2: Check session-wise limits for product groups
   * IMPORTANT: Only validates limits that are NOT NULL
   * IMPORTANT: Validates ALL product groups in a session when ANY product is entered in that session
   */
  validateProductGroupSessionLimits(date: string): { isValid: boolean, errors: string[] } {
    const errors: string[] = [];

    if (!this.min_max_limit_dict || !this.min_max_limit_dict.min_max_product_group_session_limit) {
      return { isValid: true, errors: [] };
    }

    const sessionData = this.product_form_dict[date] && this.product_form_dict[date].product;
    if (!sessionData) {
      return { isValid: true, errors: [] };
    }

    // Check which sessions have ANY products entered
    const sessionsWithProducts: { [sessionId: number]: boolean } = {};

    this.session_list.forEach(session => {
      let sessionHasProducts = false;
      if (this.product_form_dict[date] && this.product_form_dict[date].product && this.product_form_dict[date].product[session.id]) {
        Object.keys(this.product_form_dict[date].product[session.id]).forEach(productIdStr => {
          const productId = parseInt(productIdStr);
          const quantity = this.product_form_dict[date].product[session.id][productId].quantity;
          if (quantity > 0) {
            sessionHasProducts = true;
          }
        });
      }
      sessionsWithProducts[session.id] = sessionHasProducts;
    });

    // Calculate session totals for ALL product groups
    const productGroupSessionTotals: { [groupId: number]: { [sessionId: number]: number } } = {};

    // Calculate session totals for each product group
    this.product_list.forEach(product => {
      const groupId = product.product_group_id;

      this.session_list.forEach(session => {
        const quantity = (this.product_form_dict[date] && this.product_form_dict[date].product && this.product_form_dict[date].product[session.id] && this.product_form_dict[date].product[session.id][product.product_id]) ? this.product_form_dict[date].product[session.id][product.product_id].quantity : 0;
        const sessionTotal = (quantity * product.product_quantity) / 1000; // Convert to litres

        if (!productGroupSessionTotals[groupId]) {
          productGroupSessionTotals[groupId] = {};
        }

        productGroupSessionTotals[groupId][session.id] = (productGroupSessionTotals[groupId][session.id] || 0) + sessionTotal;
      });
    });

    // Check session limits for ALL product groups when ANY product is entered in that session
    Object.keys(sessionsWithProducts).forEach(sessionIdStr => {
      const sessionId = parseInt(sessionIdStr);
      const sessionHasProducts = sessionsWithProducts[sessionId];

      // If this session has ANY products entered, validate ALL product groups
      if (sessionHasProducts) {
        const sessionLimits = this.min_max_limit_dict.min_max_product_group_session_limit[sessionId];
        if (sessionLimits) {
          Object.keys(sessionLimits).forEach(groupIdStr => {
            const groupId = parseInt(groupIdStr);
            const sessionTotal = productGroupSessionTotals[groupId] ? (productGroupSessionTotals[groupId][sessionId] || 0) : 0;

            const groupSessionLimit = sessionLimits[groupId];
            const groupName = this.productGroupNames[groupId] || `Product Group ${groupId}`;
            const sessionName = this.sessionNames[sessionId] || `Session ${sessionId}`;

            // ONLY validate minimum if min_litre is NOT NULL
            if (groupSessionLimit.min_litre !== null && groupSessionLimit.min_litre !== undefined) {
              if (sessionTotal < groupSessionLimit.min_litre) {
                errors.push(`${groupName} needs at least ${groupSessionLimit.min_litre}L for ${sessionName} session (current: ${sessionTotal.toFixed(2)}L)`);
              }
            }

            // ONLY validate maximum if max_litre is NOT NULL
            if (groupSessionLimit.max_litre !== null && groupSessionLimit.max_litre !== undefined) {
              if (sessionTotal > groupSessionLimit.max_litre) {
                errors.push(`${groupName} cannot exceed ${groupSessionLimit.max_litre}L for ${sessionName} session (current: ${sessionTotal.toFixed(2)}L)`);
              }
            }
          });
        }
      }
    });

    return { isValid: errors.length === 0, errors };
  }

  /**
   * Level 3: Check individual product limits
   * IMPORTANT: Only validates limits that are NOT NULL
   * 
   * *** is_per_session FLAG BEHAVIOR ***
   * 
   * is_per_session = TRUE:
   *   - Validates Morning and Evening sessions SEPARATELY 
   *   - Each session must individually meet the min/max packet limits
   *   - Example: If min_packet = 5, then Morning session needs ≥5 AND Evening session needs ≥5
   * 
   * is_per_session = FALSE:
   *   - Validates Morning + Evening sessions COMBINED (together)
   *   - Total of both sessions must meet the min/max packet limits  
   *   - Example: If min_packet = 5, then Morning + Evening total needs ≥5
   */
  validateIndividualProductLimits(date: string): { isValid: boolean, errors: string[] } {
    const errors: string[] = [];

    if (!this.min_max_limit_dict || !this.min_max_limit_dict.min_max_product_limit) {
      return { isValid: true, errors: [] };
    }

    const sessionData = this.product_form_dict[date] && this.product_form_dict[date].product;
    if (!sessionData) {
      return { isValid: true, errors: [] };
    }

    // Track product totals (per session or per day based on is_per_session flag)
    const productDayTotals: { [productId: number]: number } = {};
    const productSessionTotals: { [productId: number]: { [sessionId: number]: number } } = {};

    // Calculate totals for each product
    this.product_list.forEach(product => {
      const productId = product.product_id;
      let dayTotal = 0;

      if (!productSessionTotals[productId]) {
        productSessionTotals[productId] = {};
      }

      this.session_list.forEach(session => {
        const quantity = (this.product_form_dict[date] && this.product_form_dict[date].product && this.product_form_dict[date].product[session.id] && this.product_form_dict[date].product[session.id][productId]) ? this.product_form_dict[date].product[session.id][productId].quantity : 0;
        productSessionTotals[productId][session.id] = quantity;
        dayTotal += quantity;
      });

      if (dayTotal > 0) {
        productDayTotals[productId] = dayTotal;
      }
    });

    // Check individual product limits - ONLY if limits are NOT NULL
    Object.keys(productDayTotals).forEach(productIdStr => {
      const productId = parseInt(productIdStr);
      const productLimit = this.min_max_limit_dict.min_max_product_limit[productId];

      if (productLimit) {
        const product = this.product_list && this.product_list.find(p => p.product_id === productId);
        const productName = product ? product.product_short_name : `Product ${productId}`;

        if (productLimit.is_per_session) {
          // is_per_session = TRUE: Validate Morning and Evening sessions SEPARATELY
          // Each session must meet the min/max limits individually
          Object.keys(productSessionTotals[productId]).forEach(sessionIdStr => {
            const sessionId = parseInt(sessionIdStr);
            const sessionQuantity = productSessionTotals[productId][sessionId];
            const sessionName = this.sessionNames[sessionId] || `Session ${sessionId}`;

            // ONLY validate minimum if min_packet is NOT NULL
            if (productLimit.min_packet !== null && productLimit.min_packet !== undefined) {
              if (sessionQuantity < productLimit.min_packet) {
                errors.push(`${productName} needs at least ${productLimit.min_packet} packets for ${sessionName} session (current: ${sessionQuantity})`);
              }
            }

            // ONLY validate maximum if max_packet is NOT NULL
            if (productLimit.max_packet !== null && productLimit.max_packet !== undefined) {
              if (sessionQuantity > productLimit.max_packet) {
                errors.push(`${productName} cannot exceed ${productLimit.max_packet} packets for ${sessionName} session (current: ${sessionQuantity})`);
              }
            }
          });
        } else {
          // is_per_session = FALSE: Validate Morning + Evening sessions COMBINED (together)
          // Total of both sessions must meet the min/max limits
          const dayQuantity = productDayTotals[productId];

          // ONLY validate minimum if min_packet is NOT NULL
          if (productLimit.min_packet !== null && productLimit.min_packet !== undefined) {
            if (dayQuantity < productLimit.min_packet) {
              errors.push(`${productName} needs at least ${productLimit.min_packet} packets per day (current: ${dayQuantity})`);
            }
          }

          // ONLY validate maximum if max_packet is NOT NULL
          if (productLimit.max_packet !== null && productLimit.max_packet !== undefined) {
            if (dayQuantity > productLimit.max_packet) {
              errors.push(`${productName} cannot exceed ${productLimit.max_packet} packets per day (current: ${dayQuantity})`);
            }
          }
        }
      }
    });

    return { isValid: errors.length === 0, errors };
  }

  /**
   * Master validation method that calls all three validation levels
   */
  validateAllLimits(date: string): { isValid: boolean, errors: string[] } {
    const allErrors: string[] = [];

    // Level 1: Product group overall limits
    const overallValidation = this.validateProductGroupOverallLimits(date);
    if (!overallValidation.isValid) {
      allErrors.push(...overallValidation.errors);
    }

    // Level 2: Product group session limits
    const sessionValidation = this.validateProductGroupSessionLimits(date);
    if (!sessionValidation.isValid) {
      allErrors.push(...sessionValidation.errors);
    }

    // Level 3: Individual product limits
    const individualValidation = this.validateIndividualProductLimits(date);
    if (!individualValidation.isValid) {
      allErrors.push(...individualValidation.errors);
    }

    return { isValid: allErrors.length === 0, errors: allErrors };
  }

  /**
   * Debug helper method to show what limits are configured
   */
  debugLimitConfiguration() {
    if (!this.min_max_limit_dict) {
      return;
    }

    // Debug whole day limits
    if (this.min_max_limit_dict.min_max_product_group_wholeday_limit) {
      Object.keys(this.min_max_limit_dict.min_max_product_group_wholeday_limit).forEach(groupId => {
        const limit = this.min_max_limit_dict.min_max_product_group_wholeday_limit[groupId];
        const groupName = this.productGroupNames[groupId] || `Group ${groupId}`;
      });
    }

    // Debug session limits
    if (this.min_max_limit_dict.min_max_product_group_session_limit) {
      Object.keys(this.min_max_limit_dict.min_max_product_group_session_limit).forEach(sessionId => {
        const sessionName = this.sessionNames[sessionId] || `Session ${sessionId}`;
      });
    }

    // Debug individual product limits  
    if (this.min_max_limit_dict.min_max_product_limit) {
      Object.keys(this.min_max_limit_dict.min_max_product_limit).forEach(productId => {
        const limit = this.min_max_limit_dict.min_max_product_limit[productId];
        const product = this.product_list && this.product_list.find(p => p.product_id == productId);
        const productName = product ? product.product_short_name : `Product ${productId}`;
      });
    }
  }

  /**
   * Validate all order dates
   */
  validateAllOrderDates() {
    let allValidationErrors: string[] = [];

    for (let i = 0; i < this.order_date_list.length; i++) {
      const date = this.order_date_list[i];
      const validation = this.validateAllLimits(date);

      if (!validation.isValid) {
        validation.errors.forEach(error => {
          allValidationErrors.push(`Date ${date}: ${error}`);
        });
      }
    }

    if (allValidationErrors.length > 0) {
      return false;
    }

    return true;
  }

  // ===== UI HELPER METHODS FOR DISPLAYING LIMITS =====

  /**
   * Calculate current totals for each product group for UI display
   */
  calculateProductGroupTotals(date: string) {
    this.productGroupTotals = {};

    if (!this.product_form_dict[date] || !this.product_form_dict[date].product) {
      return;
    }

    const sessionData = this.product_form_dict[date].product;

    // Calculate totals for each product group
    for (let i = 0; i < this.session_list.length; i++) {
      const session = this.session_list[i];
      const sessionId = session.id;

      for (let j = 0; j < this.product_list.length; j++) {
        const product = this.product_list[j];
        const productId = product.product_id;
        const productGroupId = product.product_group_id;

        const sessionEntry = sessionData[sessionId];
        const productEntry = sessionEntry ? sessionEntry[productId] : null;
        const quantity = productEntry ? productEntry.quantity || 0 : 0;

        if (quantity > 0) {
          const litres = (quantity * product.product_quantity) / 1000;

          if (!this.productGroupTotals[productGroupId]) {
            this.productGroupTotals[productGroupId] = 0;
          }

          this.productGroupTotals[productGroupId] += litres;
        }
      }
    }
  }

  /**
   * Check if a product group has whole day limits configured
   */
  hasWholeDayLimits(groupId: number): boolean {
    if (!this.min_max_limit_dict || !this.min_max_limit_dict.min_max_product_group_wholeday_limit) {
      return false;
    }
    const limits = this.min_max_limit_dict.min_max_product_group_wholeday_limit;
    const groupLimits = limits[groupId];
    // Only return true if at least one limit (min or max) is not null
    return groupLimits && (groupLimits.min_litre !== null || groupLimits.max_litre !== null);
  }

  /**
   * Get whole day limits for a product group
   */
  getWholeDayLimit(groupId: number): any {
    if (!this.min_max_limit_dict || !this.min_max_limit_dict.min_max_product_group_wholeday_limit) {
      return null;
    }
    const limits = this.min_max_limit_dict.min_max_product_group_wholeday_limit;
    return limits[groupId] || null;
  }

  /**
   * Get color for group limit display (green = valid, red = invalid, black = no limits)
   */
  getGroupLimitColor(groupId: number): string {
    if (!this.min_max_limit_dict || !this.min_max_limit_dict.min_max_product_group_wholeday_limit) {
      return 'black';
    }
    const limits = this.min_max_limit_dict.min_max_product_group_wholeday_limit;
    const limit = limits[groupId];
    if (!limit) {
      return 'black';
    }

    const current = this.productGroupTotals[groupId] || 0;

    if (limit.min_litre !== null && current < limit.min_litre) {
      return 'red';
    }

    if (limit.max_litre !== null && current > limit.max_litre) {
      return 'red';
    }

    return 'green';
  }

  /**
   * Check if a product group has session limits configured
   */
  hasSessionLimits(groupId: number): boolean {
    if (!this.min_max_limit_dict || !this.min_max_limit_dict.min_max_product_group_session_limit) {
      return false;
    }

    // Check if any session has non-null limits for this group
    const sessionLimitDict = this.min_max_limit_dict.min_max_product_group_session_limit;
    for (let sessionId of Object.keys(sessionLimitDict)) {
      const sessionLimits = sessionLimitDict[sessionId];
      if (sessionLimits && sessionLimits[groupId]) {
        const groupSessionLimit = sessionLimits[groupId];
        if (groupSessionLimit.min_litre !== null || groupSessionLimit.max_litre !== null) {
          return true;
        }
      }
    }
    return false;
  }

  /**
   * Get session minimum limit for a product group
   */
  getSessionMin(groupId: number, sessionId: number): number | null {
    if (!this.min_max_limit_dict || !this.min_max_limit_dict.min_max_product_group_session_limit || !groupId || !sessionId) {
      return null;
    }
    const sessionLimits = this.min_max_limit_dict.min_max_product_group_session_limit[sessionId];
    if (!sessionLimits || !sessionLimits[groupId]) {
      return null;
    }
    return sessionLimits[groupId].min_litre;
  }

  /**
   * Get session maximum limit for a product group
   */
  getSessionMax(groupId: number, sessionId: number): number | null {
    if (!this.min_max_limit_dict || !this.min_max_limit_dict.min_max_product_group_session_limit || !groupId || !sessionId) {
      return null;
    }
    const sessionLimits = this.min_max_limit_dict.min_max_product_group_session_limit[sessionId];
    if (!sessionLimits || !sessionLimits[groupId]) {
      return null;
    }
    return sessionLimits[groupId].max_litre;
  }

  /**
   * Get current session total for a product group
   */
  getSessionCurrent(groupId: number, sessionId: number): number {
    if (!this.product_form_dict || !this.product_form_dict[this.form_start_date] || !this.product_form_dict[this.form_start_date].product) {
      return 0;
    }

    const sessionData = this.product_form_dict[this.form_start_date].product;
    let total = 0;

    // Calculate total for this product group in this session
    this.product_list.forEach(product => {
      if (product.product_group_id === groupId) {
        const sessionEntry = sessionData[sessionId];
        const productEntry = sessionEntry ? sessionEntry[product.product_id] : null;
        const quantity = productEntry ? productEntry.quantity || 0 : 0;
        total += (quantity * product.product_quantity) / 1000;
      }
    });

    return total;
  }

  /**
   * Get color for session limit display
   */
  getSessionLimitColor(groupId: number, sessionId: number): string {
    const current = this.getSessionCurrent(groupId, sessionId);
    const minLimit = this.getSessionMin(groupId, sessionId);
    const maxLimit = this.getSessionMax(groupId, sessionId);

    if (minLimit !== null && current < minLimit) {
      return 'red';
    }

    if (maxLimit !== null && current > maxLimit) {
      return 'red';
    }

    return 'green';
  }

}
